'use client'

import { styled } from '@pattern-library/stitches.config'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

import { Button } from '../basicUI/Button'
import { Flex } from '../basicUI/Flex'
import { Gutter } from '../basicUI/Gutter'
import { Text } from '../basicUI/Text'

export const NotFound = () => {
  // Inspiration: https://codepen.io/tripti1410/pen/jOBEYXX
  const t = useTranslations('PLNotFound')
  return (
    <Container>
      <Flex align="center" direction={'column'} justify={'center'}>
        <Gutter>
          <Flex align="center" direction={'column'} justify={'center'} gap={5}>
            <Text variant="h1">404</Text>
            <Text variant="subtitle1">{t('message')}</Text>
            <Link href="/" style={{ textDecoration: 'none' }}>
              <Button label={t('goBack')} />
            </Link>
          </Flex>
        </Gutter>
      </Flex>
    </Container>
  )
}

const Container = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  aligItems: 'center',
  textAlign: 'center',
  minHeight: '100dvh',
  minWidth: '100dvw',
})
